module.exports = __webpack_public_path__ + "static/media/sa2.6f0ee169.png";